// extracted by mini-css-extract-plugin
export default {"page":"styles_page__a3+d4","heading":"styles_heading__LQ5Ga","main":"styles_main__lBkoC","container":"styles_container__Zp7N7","well":"styles_well__YTVcS"};